import {object} from "@src/libs/yup";

export default () => object({}).validate({});